export enum ProjectStatusesEnum {
  InProgress = 'in_progress',
  Finished = 'finished',
  BehindSchedule = 'behind_schedule',
  OverBudget = 'over_budget'
}
